import { render, staticRenderFns } from "./Question.vue?vue&type=template&id=38f1ec3f&scoped=true"
import script from "./Question.vue?vue&type=script&lang=js"
export * from "./Question.vue?vue&type=script&lang=js"
import style0 from "./Question.vue?vue&type=style&index=0&id=38f1ec3f&prod&scoped=true&lang=css"
import style1 from "./Question.vue?vue&type=style&index=1&id=38f1ec3f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f1ec3f",
  null
  
)

export default component.exports